<template>
    <div class="toast-container">
        <transition-group name="toast">
            <Toast v-for="toast in toasts"
                   :key="toast.id"
                   :message="toast.message"
                   :type="toast.type"
                   :duration="toast.duration"
            />
        </transition-group>
    </div>
</template>

<script setup lang="ts">
    const { $toast } = useNuxtApp()
    const toasts = ref($toast?.toasts || [])
</script>

<style scoped>
    .toast-container {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 9999;
        display: flex;
        flex-direction: column-reverse;
        gap: 10px;
    }
</style>
